import { render, staticRenderFns } from "./form-radio.vue?vue&type=template&id=7c256881&scoped=true&"
import script from "./form-radio.vue?vue&type=script&lang=ts&"
export * from "./form-radio.vue?vue&type=script&lang=ts&"
import style0 from "./form-radio.vue?vue&type=style&index=0&id=7c256881&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c256881",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VCol,VRadio,VRadioGroup})
